import { Controller } from 'stimulus'
import { getRequest } from  '@react/helpers/fetch'
import { pathname }   from  '@react/helpers/fetch'

export default class extends Controller {
  static targets = ["fields", "select", "warning"]

  change() {
    const category = this.selectTarget.value
    this.applyDuration(category)
    if (this.hasWarningTarget) { this.warningTarget.classList.remove("d-none") }
    if (category) {
      const path     = this.data.get("path")
      const recordId = this.data.get("recordId")
      const params   = recordId ? { id: category, record_id: recordId } : { id: category }
      const format   = "json"
      const url      = pathname({ path, params, format })

      getRequest(url)
      .then(response => this.fieldsTarget.innerHTML = response.html)
    } else {
      this.fieldsTarget.innerHTML = ""
    }
  }

  // The passages component listens to the hidden field; the time picker also needs its date set.
  applyDuration(category) {
    const durations = JSON.parse(this.data.get("durations") || "{}")
    const minutes   = durations[category]
    if (!minutes) return

    const form = this.element.closest("form") || document
    // A preventive workorder's duration is the sum of its maintenance tasks.
    const type = form.querySelector('[name="workorder[workorder_type]"]')
    if (type && type.value === "Preventive") return

    const passagesInput = form.querySelector("#hidden_predicted_duration")
    if (passagesInput) {
      passagesInput.value = minutes
      passagesInput.dispatchEvent(new Event("change"))
    }

    form.querySelectorAll('[data-controller~="flatpickr-time"]').forEach(group => {
      const hidden = group.querySelector('[data-target~="flatpickr-time.hidden"]')
      const input  = group.querySelector('[data-target~="flatpickr-time.input"]')
      if (hidden) hidden.value = minutes
      if (input && input._flatpickr) input._flatpickr.setDate(new Date(0, 0, 1, Math.floor(minutes / 60), minutes % 60), false)
    })
  }
}
